export const map = {
  CASH_EQUITY: "3afc4770-c797-4bad-b2b4-c57d8fafbc13",
  DEBT_MF_UNIT: "04c04e4d-a8c3-11e9-8b5f-00ff12c3b408",
  LENDER: "7d8f1df5-3f5e-11e9-bf92-0242ac140002",
  ALL_IN_RATE: "7d8f1ebf-3f5e-11e9-bf92-0242ac140002",
  LOAN_SPREAD: "7d8f1f1d-3f5e-11e9-bf92-0242ac140002",
  TEAM_MEMBER: "7d8f1f7d-3f5e-11e9-bf92-0242ac140002",
  STATE: "7d8f1fdf-3f5e-11e9-bf92-0242ac140002",
  CITY: "7d8f20f2-3f5e-11e9-bf92-0242ac140002",
  MF_UNITS: "7d8f2160-3f5e-11e9-bf92-0242ac140002",
  SQUARE_FEET: "7d8f21c6-3f5e-11e9-bf92-0242ac140002",
  ASSET_CLASS: "7d8f222e-3f5e-11e9-bf92-0242ac140002",
  ASSET_TYPE: "7d8f228b-3f5e-11e9-bf92-0242ac140002",
  OCCUPANCY: "7d8f22f6-3f5e-11e9-bf92-0242ac140002",
  NOI: "7d8f2362-3f5e-11e9-bf92-0242ac140002",
  NOI_ACTUAL: "fe2a59fe-c825-11e9-a4f9-00ff12c3b408",
  BROKER_COMPANY: "7d8f23ce-3f5e-11e9-bf92-0242ac140002",
  PURCHASE_PRICE: "7d8f242d-3f5e-11e9-bf92-0242ac140002",
  APPRAISED_VALUE: "7d8f248e-3f5e-11e9-bf92-0242ac140002",
  DESIRED_LOAN_AMOUNT: "7d8f24ef-3f5e-11e9-bf92-0242ac140002",
  FUND: "7d8f2560-3f5e-11e9-bf92-0242ac140002",
  STAGE: "7d8f25cf-3f5e-11e9-bf92-0242ac140002",
  TARGETED_CLOSE: "7d8f2642-3f5e-11e9-bf92-0242ac140002"
};
export const list = Object.values(map);
export default {
  map,
  list
};
